module.exports = __webpack_public_path__ + "img/new-password.ed8d228e.png";